module.exports = __webpack_public_path__ + "img/slide-next.3cbb70f0.svg";